import { useBrandingStore } from '@/store/branding.store';

export function useBranding() {
  return useBrandingStore((s) => s.branding);
}
